@if (pins().length > 0) {
  <section class="freigabe-status" data-testid="freigabe-status" aria-labelledby="freigabe-status-title">
    <h2 id="freigabe-status-title" class="freigabe-status__title">
      {{ 'liveDashboard.freigabeStatus.title' | translate }}
    </h2>
    <div class="freigabe-status__grid">
      @for (pin of pins(); track pin.id) {
        <app-freigabe-kachel [pin]="pin" [showProject]="showProject()" (remove)="onRemove($event)" />
      }
    </div>
  </section>
}
